import { render } from "./OrderFormTab.vue?vue&type=template&id=64e199a8&scoped=true"
import script from "./OrderFormTab.vue?vue&type=script&lang=js"
export * from "./OrderFormTab.vue?vue&type=script&lang=js"

import "./OrderFormTab.vue?vue&type=style&index=0&id=64e199a8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e199a8"]])

export default __exports__